export default __webpack_public_path__ + "static/media/mosaic2.dac0364c.png";